import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getPublicGameTitle} from '../../../../constants/gameType.constants';
import Paginate from '../../../Common/Paginate';
import {fetchProductBillingRecordsForCurrentUser} from '../../../../actions/usageStatus.actions';
import {
  formatDateToYYYYMMDDhhmmss,
  convertTimeCreditToPcBangPoint,
  calculateTimeDiff,
} from '../../../../util/timeUtils';

import './productBillingRecordsModal.scss';
import {Table, PcBangPopup} from '../../../Common/PageComponents';

const stateToProps = state => {
  return {
    productBillingRecords: state.usageStatus.productBillingRecords.content,
    pageNumber: state.usageStatus.productBillingRecords.pageNumber,
    totalItemCount: state.usageStatus.productBillingRecords.totalItemCount,
    entitlementIdOfProductBillingRecords: state.usageStatus.productBillingRecords.productEntitlementId,
  };
};

class ProductBillingRecordsModal extends Component {
  _movePage(pageNumber) {
    this.props.dispatch(fetchProductBillingRecordsForCurrentUser(this.props.productEntitlementId, pageNumber));
  }

  _renderProductBillingRecords(productBillingRecords) {
    if (!productBillingRecords || productBillingRecords.length == 0) {
      return (
        <tr>
          <td colSpan="6" className="end">
            사용 기록이 없습니다.
          </td>
        </tr>
      );
    }
    return productBillingRecords.map((record, index) => (
      <tr key={index}>
        <td>{getPublicGameTitle(record.gameType)}</td>
        <td>{record.identificationValue}</td>
        <td>{formatDateToYYYYMMDDhhmmss(record.billingStart)}</td>
        <td>{formatDateToYYYYMMDDhhmmss(record.billingEnd)}</td>
        <td>{calculateTimeDiff(record.billingStart, record.billingEnd)}</td>
        <td>{convertTimeCreditToPcBangPoint(record.billableTime, 1)}</td>
      </tr>
    ));
  }

  shouldComponentUpdate(nextProps) {
    let entitlementIdOfProductBillingRecords = this.props.entitlementIdOfProductBillingRecords;
    if (
      nextProps.productEntitlementId == entitlementIdOfProductBillingRecords &&
      entitlementIdOfProductBillingRecords
    ) {
      return true;
    }
    return false;
  }

  render() {
    return (
      <PcBangPopup
        closeOnDocumentClick
        contentStyle={{width: '75%', minWidth: '800px', maxWidth: '1000px'}}
        onOpen={() => this._movePage(1)}
        trigger={this.props.children}
        title={'상세사용내역'}
      >
        <p style={{margin: '0px 0 10px', textAlign: 'right'}}>
          ※소진 포인트는 소수점 첫째짜리 이하 반올림하여 표기됩니다.
        </p>
        <Table>
          <colgroup>
            <col width="15%" />
            <col width="18%" />
            <col width="20%" />
            <col width="20%" />
            <col width="15%" />
            <col width="*" />
          </colgroup>
          <thead>
            <tr>
              <th>게임</th>
              <th>IP</th>
              <th>시작시간</th>
              <th>종료시간</th>
              <th>사용시간</th>
              <th>소진포인트</th>
            </tr>
          </thead>
          <tbody>{this._renderProductBillingRecords(this.props.productBillingRecords)}</tbody>
        </Table>
        <Paginate
          currentPage={this.props.pageNumber}
          totalItemCount={this.props.totalItemCount}
          onChange={this._movePage.bind(this)}
        />
        <div style={{textAlign: 'right'}}>과금율: 리그 오브 레전드= 1.0, 발로란트= 1.1</div>
      </PcBangPopup>
    );
  }
}

export default connect(stateToProps)(ProductBillingRecordsModal);
